import React from 'react'
import { FormattedMessage } from 'react-intl'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { theme as deprecatedTheme } from '../../styled'

export function OrganizationFlagBetaBadge() {
  return (
    <FormattedMessage
      id="detail_beta"
      children={(msg) => (
        <div
          className={css`
            font-size: 10px;
            font-weight: ${deprecatedTheme.fontWeights.primary.bold};
            background-color: ${theme.color.neutral100};
            color: ${theme.color.white};
            border-radius: 10px;
            width: fit-content;
            padding: 0 6px;
            margin-right: 12px;
          `}
        >
          {msg}
        </div>
      )}
    />
  )
}
